import React from 'react';
import CarouselBlock from './CarouselBlock';
import { puckMediaFitField } from '../../../media';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { puckSwitchField } from '../../../puck/fields/puckSwitchField';
import CarouselThumbnailsField from './CarouselThumbnailsField';
import CarouselPlaybackField from './CarouselPlaybackField';
import CarouselSlidesVisibleField from './CarouselSlidesVisibleField';
import CarouselSlidesField from './CarouselSlidesField';
import CarouselStylePicker from './CarouselStylePicker';
import { carouselDefaultProps } from './carouselDefaults';
import { puckAdvancedSectionField, puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import {
  themedBlockProps, themedBlockResolveData, themedBlockResolveFields,
} from '../../../puck/themedBlocks';

const carouselBlockConfig = {
  label: 'Carrousel',
  defaultProps: carouselDefaultProps(),
  // Titres et descriptions des slides s'éditent UNIQUEMENT sur le canvas.
  // Le cadrage est au niveau du bloc : répété par slide, il donnait deux
  // champs de plus par slide pour un rendu qui doit rester homogène.
  fields: withThemedFieldValues('carousel', {
    // Les slides d'abord : c'est le champ le plus utilisé.
    _section1: puckSectionField('Contenu'),
    slides: {
      type: 'custom',
      label: 'Slides',
      render: (props) => <CarouselSlidesField {...props} />,
    },
    showSlideText: puckSwitchField(
      'Textes des slides',
      'Décoché, la slide n’est que son média — le cas d’un bandeau de logos.',
    ),

    _sectionGallery: puckStyleGallerySectionField('Carrousel'),
    // Le catalogue de styles en tête : un clic pose un jeu de réglages complet,
    // les champs qui suivent servent à s'en écarter. Déclaré sur `loop` faute
    // de prop « style » — c'est la seule prop de style sans champ à elle, et le
    // sélecteur les écrit toutes par dispatch (cf. CarouselStylePicker).
    loop: {
      type: 'custom',
      label: 'Style du carrousel',
      render: () => <CarouselStylePicker />,
    },

    _section2: puckSectionField('Style'),
    // Puis « combien de slides » : c'est ce réglage qui gouverne quels autres
    // s'affichent et à quoi ressemble le bloc.
    maxSlidesVisible: {
      type: 'custom',
      label: 'Slides visibles',
      render: (props) => <CarouselSlidesVisibleField {...props} />,
    },
    height: puckPxSpacingField('Hauteur des slides', undefined, { max: 800 }),

    _sectionText: puckSectionField('Typographie'),
    textStyles: puckTextRolesField([{ key: 'title', label: 'Titre des slides' }, { key: 'description', label: 'Description des slides' }]),

    _section3: puckSectionField('Animation'),
    thumbnails: { type: 'custom', label: 'Navigation par miniatures', render: (props) => <CarouselThumbnailsField {...props} /> },
    autoplay: {
      type: 'custom',
      label: 'Lecture & navigation',
      render: (props) => <CarouselPlaybackField {...props} />,
    },

    _section4: puckAdvancedSectionField(),
    slideGap: puckPxSpacingField('Espacement entre les slides'),
    mediaFit: { ...puckMediaFitField, label: 'Cadrage du média de fond' },
  }),
  // Suit son style du thème, s'il en a un, retouches du thème comprises
  // (lien vivant, cf. puck/themedBlocks).
  resolveData: themedBlockResolveData('carousel'),
  resolveFields: themedBlockResolveFields('carousel'),
  render: (props) => <CarouselBlock {...themedBlockProps('carousel', props, props.puck?.metadata)} />,
};

export default carouselBlockConfig;
